
import { defineComponent } from 'vue';
import PopButton from './PopButton.vue';
import { PopRowState, tableRef } from './PopBoard.vue';

const COLOR_NORMAL = 'rgb(190, 190, 190)';
const COLOR_ACTIVE = 'rgb(255, 29, 29)';

export default defineComponent({
  name: 'PopRow',
  props: {
    stateObj: {
      type: PopRowState,
      required: true,
    },
    rowID: {
      type: Number,
      required: true,
    },
  },
  components: {
    PopButton,
  },
  data() {
    return {
      computedColor: COLOR_NORMAL,
    };
  },
  methods: {
    getColor() : string {
      return (tableRef.value.currActiveRow === this.rowID) ? COLOR_ACTIVE : COLOR_NORMAL;
    },
    getWinner() : boolean {
      return (tableRef.value.winner !== -1);
    },
  },
});
